import { render, staticRenderFns } from "./RequiredActionProjects.vue?vue&type=template&id=159080b7&scoped=true"
import script from "./RequiredActionProjects.vue?vue&type=script&lang=js"
export * from "./RequiredActionProjects.vue?vue&type=script&lang=js"
import style0 from "./RequiredActionProjects.vue?vue&type=style&index=0&id=159080b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159080b7",
  null
  
)

export default component.exports